export default "__VITE_ASSET__DU356sid__"